// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Nv-z","tooltipWrapper":"Ov-z","icon":"Pv-z","tooltip":"Qv-z","content":"Rv-z"};